import React, { useRef, useLayoutEffect, useState } from "react";
import styles from "./styles/ScenarioCardTagsRow.module.css";

const ScenarioCardTagsRow = ({ tags, searchQuery, highlightText, handleTagClick }) => {
  const containerRef = useRef(null);
  const tagRefs = useRef([]);
  const [visibleCount, setVisibleCount] = useState(tags.length);

  useLayoutEffect(() => {
    if (!containerRef.current) return;

    const containerWidth = containerRef.current.offsetWidth;
    let usedWidth = 0;
    let count = 0;

    for (let i = 0; i < tagRefs.current.length; i++) {
      const tag = tagRefs.current[i];
      if (!tag) continue;

      const tagWidth = tag.offsetWidth + 6; // include gap
      if (usedWidth + tagWidth > containerWidth) break;

      usedWidth += tagWidth;
      count++;
    }

    setVisibleCount(count);
  }, [tags]);

  return (
    <div ref={containerRef} className={styles.tagsRow}>
      {tags.slice(0, visibleCount).map((tag, index) => (
        <button
          key={tag._id}
          ref={(el) => (tagRefs.current[index] = el)}
          className={styles.tagButton}
          onClick={(e) => {
            e.stopPropagation();
            handleTagClick(tag.name);
          }}
          title={`Filter by tag: ${tag.name}`}
        >
          {highlightText ? highlightText(tag.name, searchQuery) : tag.name}
        </button>
      ))}
    </div>
  );
};

export default ScenarioCardTagsRow;